import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/index';
import Modal from 'components/Modal/index';
import ModalButtons from 'components/Modal/ModalButtons/index';
import LoadingCircle from "../../LoadingCircle";

export default class ConfirmModal extends React.Component {
    static propTypes = {
        confirmOnClick: PropTypes.func.isRequired,
        confirmText: PropTypes.string.isRequired,
        content: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]),
        declineOnClick: PropTypes.func,
        declineText: PropTypes.string,
        show: PropTypes.bool.isRequired,
        showActivityIndicator: PropTypes.bool,
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ])
    };

    render() {
        let showDeclineButton = this.props.declineOnClick != null && this.props.declineText != null;

        return (
            <Modal className="a-modal--confirm-modal"
                   contentLabel="Please confirm in this modal"
                   show={this.props.show}
                   title={this.props.title}>
                <div className="confirm-modal__content">
                    {this.props.content}
                </div>

                <ModalButtons buttonCount={showDeclineButton === true ? 2 : 1}>
                    <Button disabled={this.props.showActivityIndicator}
                            onClick={this.props.confirmOnClick.bind(this)}
                            type="button">
                        {this.props.confirmText}

                        {this.props.showActivityIndicator && <LoadingCircle />}
                    </Button>

                    {showDeclineButton === true ? (
                        <Button className="a-button--grey"
                                cancelStyles
                                disabled={this.props.showActivityIndicator}
                                onClick={this.props.declineOnClick.bind(this)}
                                type="button">
                            {this.props.declineText}
                        </Button>
                    ) : null}
                </ModalButtons>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Modal/ConfirmModal/index.js